import { Component, Input } from '@angular/core';

@Component({
    selector: 'cna-icon-tile',
    templateUrl: './icon-tile.component.html',
    styleUrls: ['./icon-tile.component.scss'],
})
export class IconTileComponent {
    @Input() tileTitle: string;
    @Input() tileImage: string; // format: assets/test.png
    @Input() routeLink: string;
    @Input() isDeactivated = false;
}
